import React from 'react';
import { Box, Button, Text } from '@chakra-ui/react';
import xhr from 'xhr';

function ResetBoletines() {
  const [isFetching, setIsFetching] = React.useState(false);

  const handleResetBoletines = async () => {
    try {
      const confirmed = window.confirm(
        '¿Seguro que deseas resetear todos los boletines activos?'
      );

      if (!confirmed) return;

      setIsFetching(true);

      const response = await xhr.put('/students/reset-boletines', {});

      alert(
        `${response.data.message}. Registros actualizados: ${response.data.updated}`
      );
    } catch (error) {
      console.error(error);
      alert('Ocurrió un error al resetear los boletines');
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <Box
      background="white"
      borderRadius="23px"
      boxShadow="0px 3px 6px #A549E914"
      padding="20px"
    >
      <Text fontSize="20px" fontWeight="bold" marginBottom="10px">
        Resetear boletines
      </Text>

      <Text marginBottom="15px">
        Esta acción pondrá en false todos los estudiantes que tengan el campo
        boletin en true.
      </Text>

      <Button
        colorScheme="red"
        onClick={handleResetBoletines}
        isLoading={isFetching}
      >
        Resetear boletines
      </Button>
    </Box>
  );
}

export default ResetBoletines;